import React, { useState, useEffect } from "react";

// Components
import Sidebar from "../../components/Sidebar";
import Main from "./TbSetUnit/Main";
import Form from "./TbSetUnit/Form";

// Utils
import { getDataWithComp, getAlert } from "../../../utils/SamuiUtils";
import { InitialDataTbSetItem } from "../../../model/InitialData/InitialDataTbSetItem";

const TbSetUnit = () => {
  const [mode, setMode] = useState("");
  const [dataMasterList, setDataMasterList] = useState([]);
  const [selectedData, setSelectedData] = useState(null);
  const [formData, setFormData] = useState(InitialDataTbSetItem());

  useEffect(() => {
    initialize();
  }, []);

  const initialize = async () => {
    try {
      setMode("S");
      fetchRealtime();
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const fetchRealtime = async () => {
    try {
      const masterList = await getDataWithComp(
        "Tb_Set_Unit",
        "Order By Unit_Id"
      );
      if (masterList && masterList.length > 0) {
        setDataMasterList(masterList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };

  const onPageInsert = () => {
    setMode("I");
  };

  const onRowSelected = (item) => {
    setMode("U");
    setFormData({
      comp_id: item.Comp_Id,
      Unit_Id: item.Unit_Id,
      Unit_Name: item.Unit_Name,
      Unit_Status: item.Unit_Status,
    });
    setSelectedData(item);
  };

  return (
    <div className="TbSetUnit">
      <div className="wrapper">
        <Sidebar />
        <div className="main-panel">
          <div className="container">
            <div className="page-inner">
              <div style={{ display: mode === "S" ? "block" : "none" }}>
                <Main
                  masterList={dataMasterList}
                  name={"ข้อมูลหน่วยนับ"}
                  onPageInsert={() => onPageInsert()}
                  onRowSelected={(item) => onRowSelected(item)}
                />
              </div>
              <div style={{ display: mode !== "S" ? "block" : "none" }}>
                <Form
                  callInitialize={initialize}
                  mode={mode}
                  name={"ข้อมูลหน่วยนับ"}
                  formData={formData}
                  setFormData={setFormData}
                  selectedData={selectedData}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TbSetUnit;
